import React from 'react';
import { Plus360Boundary } from '../plus/Plus360Boundary';

// Depuis 360+ : un seul palier. Les anciennes gardes par module délèguent au teaser 360+.
export const ModuleAccessBoundary = ({ moduleKey, title, children }) => <Plus360Boundary moduleKey={moduleKey} title={title}>{children}</Plus360Boundary>;
